import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/AlignCenterHorizontal.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: a }));
e.displayName = "AlignCenterHorizontalIcon";
const m = e;
export {
  m as AlignCenterHorizontal,
  e as AlignCenterHorizontalIcon
};
